import React from 'react';

// Title, one line of explanation, and the action that resolves it - the
// action lives here rather than in a page corner the user has to hunt for.
export default function EmptyState({ icon, title, text, children }) {
  return (
    <div className="empty-state">
      {icon}
      {title && <div className="empty-state-title">{title}</div>}
      {text && <div className="empty-state-text">{text}</div>}
      {children && <div className="empty-state-actions">{children}</div>}
    </div>
  );
}
